import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextButton, Popover, Button } from 'wix-style-react';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import s from './baseFilter.scss';

class BaseFilter extends Component {
  constructor(props) {
    super(props);
    this.state = { isFilterOpen: false };
  }

  static propTypes = {
    filterDataHook: PropTypes.string,
    filterTitle: PropTypes.string,
    applyButtonDataHook: PropTypes.string,
    clearButtonDataHook: PropTypes.string,
    applyButtonText: PropTypes.string,
    clearButtonText: PropTypes.string,
    onApply: PropTypes.func,
    onClear: PropTypes.func,
    isClearDisabled: PropTypes.bool,
    children: PropTypes.node,
  };

  toggleFilterOpen() {
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  }

  onClickOutside() {
    if (this.state.isFilterOpen) {
      this.props.onApply();
      this.toggleFilterOpen();
    }
  }

  onBaseFilterApply() {
    this.props.onApply();
    this.toggleFilterOpen();
  }

  render() {
    const {
      filterDataHook,
      filterTitle,
      applyButtonDataHook,
      clearButtonDataHook,
      applyButtonText,
      clearButtonText,
      onClear,
      isClearDisabled,
      children,
    } = this.props;
    const { isFilterOpen } = this.state;

    return (
      <Popover
        animate
        appendTo="window"
        flip={false}
        onClick={() => this.toggleFilterOpen()}
        placement="bottom"
        showArrow
        shown={isFilterOpen}
        onClickOutside={() => this.onClickOutside()}
        dataHook={filterDataHook}
      >
        <Popover.Element>
          <TextButton skin="dark" suffixIcon={<ChevronDown />}>
            {filterTitle}
          </TextButton>
        </Popover.Element>
        <Popover.Content>
          <div
            className={s.filterWrapper}
            style={{ display: isFilterOpen ? 'block' : 'none' }}
          >
            <div className={s.filterHeader} />
            <div className={s.filterContent}>{children}</div>
            <div className={s.footerWrapper}>
              <TextButton
                dataHook={clearButtonDataHook}
                onClick={onClear}
                disabled={isClearDisabled}
              >
                {clearButtonText}
              </TextButton>
              <Button
                dataHook={applyButtonDataHook}
                onClick={() => this.onBaseFilterApply()}
              >
                {applyButtonText}
              </Button>
            </div>
          </div>
        </Popover.Content>
      </Popover>
    );
  }
}

export default BaseFilter;
